module.exports = __webpack_public_path__ + "img/icon-flag-es.198a19c6.svg";